const u = () => {
  const { userAgent: t } = navigator;
  return t.match(/Android/i) || t.match(/iPhone|iPad|iPod/i) ? !0 : !(t.match(/Windows/i) || t.match(/Macintosh/i));
};
function s(t) {
  return Object.entries(t).filter(([, r]) => r).map(([r]) => r).join(" ");
}
const c = (t = 0) => {
  const r = t ?? 0, i = Math.trunc(r) || 0, e = Math.floor((r - i) * 60) || 0;
  return {
    fullTime: `${i !== 0 ? `${i}시간` : ""}${e !== 0 ? ` ${e}분` : ""}` || "0분",
    hour: i,
    minute: e
  };
}, a = (t) => t != null, o = (t, r = 2) => {
  if (t == null || Number.isNaN(Number(t)))
    return 0;
  const i = `${t}`;
  if (!i.includes("e"))
    return +`${Math.round(parseFloat(`${t}e+${r}`))}e-${r}`;
  const e = i.split("e");
  let n = "";
  return +e[1] + r > 0 && (n = "+"), +`${Math.round(parseFloat(`${+e[0]}e${n}${+e[1] + r}`))}e-${r}`;
}, d = (t, r = 2) => t == null || Number.isNaN(t) ? "-" : o(t, r);
export {
  u as checkIsMobile,
  s as cn,
  d as displayRoundNum,
  c as formatTime,
  a as isDefined,
  o as roundNum
};
//# sourceMappingURL=index.js.map
